<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { RendererBridge, canUseWebGL2Renderer, detectRendererCapabilities } from './rendererBridge';

  let canvasEl: HTMLCanvasElement;
  let bridge: RendererBridge | null = null;
  let mode = '...';
  let frameTime = 0;
  let raf = 0;
  let errorMsg = '';
  let caps = detectRendererCapabilities();

  onMount(() => {
    if (!canUseWebGL2Renderer()) {
      errorMsg = 'WebGL2 renderer non disponibile su questo browser';
      return;
    }

    bridge = new RendererBridge(canvasEl, {
      onResult(bitmap, m, ft) {
        mode = m;
        frameTime = ft;
        const ctx = canvasEl.getContext('2d');
        if (ctx) {
          ctx.drawImage(bitmap, 0, 0, canvasEl.width, canvasEl.height);
          bitmap.close();
        }
      },
      onError(reason) {
        errorMsg = reason;
      }
    });

    bridge.init(400, 400, true).then(() => {
      // After init, render a test SDF polygon (star shape)
      const cx = 200, cy = 200, r = 120;
      const verts = new Float32Array(20 * 2);
      for (let i = 0; i < 20; i++) {
        const angle = (i / 20) * Math.PI * 2;
        const radius = i % 2 === 0 ? r : r * 0.5;
        verts[i * 2] = cx + Math.cos(angle) * radius;
        verts[i * 2 + 1] = cy + Math.sin(angle) * radius;
      }
      bridge?.renderSDF(verts, 400, 400);
    }).catch((e) => {
      errorMsg = e instanceof Error ? e.message : 'init_error';
    });
  });

  onDestroy(() => {
    cancelAnimationFrame(raf);
    bridge?.destroy();
  });
</script>

<div class="p-4 space-y-2">
  <h3 class="font-semibold">WebGL2 Renderer Debug</h3>
  <div class="text-sm text-gray-600 space-y-1">
    <p>WebGL2: {caps.webgl2 ? 'sì' : 'no'}</p>
    <p>Half-float: {caps.halfFloat ? 'sì' : 'no'}</p>
    <p>P3: {caps.p3 ? 'sì' : 'no'}</p>
    <p>OffscreenCanvas: {caps.offscreenCanvas ? 'sì' : 'no'}</p>
    <p>Modalità: <span class="font-mono font-bold text-pink-600">{mode}</span></p>
    <p>Frame time: <span class="font-mono">{frameTime.toFixed(2)} ms</span></p>
  </div>
  {#if errorMsg}
    <p class="text-red-600 text-sm">Errore: {errorMsg}</p>
  {/if}
  <canvas bind:this={canvasEl} width="400" height="400" class="rounded-lg shadow border" style="width: 400px; height: 400px;"></canvas>
</div>
